module.exports = __webpack_public_path__ + "static/media/18ECA48.26b5eb23.jpg";